import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["isAsyncInputClearable", "searchCloseIconClass"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { components as defaultComponents } from 'react-select';
import { defaultMemoize } from 'reselect';
import _isEmpty from 'lodash/isEmpty';
import _noop from 'lodash/noop';
import _debounce from 'lodash/debounce';
import _isObject from 'lodash/isObject';
import _map from 'lodash/map';
import _keyBy from 'lodash/keyBy';
import _castArray from 'lodash/castArray';
import _isEqual from 'lodash/isEqual';
import { EMPTY_ARRAY, EMPTY_OBJECT, EMPTY_STRING } from '@tekion/tekion-base/app.constants';
import { getSelectStyles } from '../styles/AdvancedSelect.styles';
import { SIZES } from '../../../atoms/FontIcon';
import withWrappedMenuList from './withWrappedMenuList';
import IconAsBtn from '../../../atoms/iconAsBtn';
var DELAY_SEARCH_BY = 800;
var DELAY_SCROLL_BY = 400;
var getSanitizedValue = function getSanitizedValue() {
  return defaultMemoize(function (creatableOptions, selectedValue) {
    var optionsByValue = _keyBy(creatableOptions, 'value');
    return _map(_castArray(selectedValue), function (value) {
      if (_isObject(value)) return value;
      if (optionsByValue[value]) return optionsByValue[value];
      return value;
    });
  });
};
export default function WithAsyncSelectHOC(SelectComponent) {
  var WithAsyncSelect = /*#__PURE__*/function (_PureComponent) {
    _inherits(WithAsyncSelect, _PureComponent);
    var _super = _createSuper(WithAsyncSelect);
    function WithAsyncSelect(props) {
      var _this;
      _classCallCheck(this, WithAsyncSelect);
      _this = _super.call(this, props);
      _defineProperty(_assertThisInitialized(_this), "getSelectStyles", defaultMemoize(getSelectStyles));
      _defineProperty(_assertThisInitialized(_this), "getSelectComponents", defaultMemoize(function (userOverideComponents, shouldIncludeDefaultComponents) {
        if (shouldIncludeDefaultComponents) {
          var components = _objectSpread(_objectSpread({}, defaultComponents), userOverideComponents);
          return _objectSpread(_objectSpread({}, components), {}, {
            MenuList: withWrappedMenuList(components.MenuList)
          });
        }
        return _objectSpread(_objectSpread({}, userOverideComponents), {}, {
          MenuList: withWrappedMenuList(defaultComponents.MenuList)
        });
      }));
      _defineProperty(_assertThisInitialized(_this), "onMenuOpen", function () {
        _this.setState({
          isMenuOpen: true
        });
      });
      _defineProperty(_assertThisInitialized(_this), "onMenuClose", function () {
        var onMenuClose = _this.props.onMenuClose;
        _this.setState({
          isMenuOpen: false
        });
        onMenuClose();
      });
      _defineProperty(_assertThisInitialized(_this), "loadOptions", function (inputValue) {
        var isOnScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var additional = arguments.length > 2 ? arguments[2] : undefined;
        var _this$props = _this.props,
          loadOptions = _this$props.loadOptions,
          onLoadOptionsSuccess = _this$props.onLoadOptionsSuccess;
        var _this$state = _this.state,
          page = _this$state.page,
          loadedOptions = _this$state.loadedOptions;
        var newPage = isOnScroll ? page + 1 : 0;
        loadOptions(inputValue, newPage, additional, isOnScroll).then(function (_ref) {
          var options = _ref.options,
            hasMore = _ref.hasMore;
          onLoadOptionsSuccess({
            options: options,
            hasMore: hasMore
          });
          if (!_this.setState) return;
          _this.setState({
            isLoading: false,
            hasMore: hasMore,
            page: newPage,
            loadedInputValue: inputValue,
            loadedOptions: isOnScroll ? [].concat(_toConsumableArray(loadedOptions), _toConsumableArray(options)) : options
          });
        })["catch"](function () {
          return _this.setState({
            isLoading: false
          });
        });
      });
      _defineProperty(_assertThisInitialized(_this), "handleOnScroll", function () {
        var _this$state2 = _this.state,
          hasMore = _this$state2.hasMore,
          loadedInputValue = _this$state2.loadedInputValue;
        if (!hasMore) return;
        _this.loadOptions(loadedInputValue, true);
      });
      _defineProperty(_assertThisInitialized(_this), "handleChange", function (values, eventDetails) {
        var onChange = _this.props.onChange;
        var creatableOptions = _this.state.creatableOptions;
        if (eventDetails.action !== 'create-option') return onChange(values, eventDetails);
        _this.setState({
          creatableOptions: [].concat(_toConsumableArray(creatableOptions), _toConsumableArray(_castArray(values)))
        });
        return onChange(values, eventDetails);
      });
      _defineProperty(_assertThisInitialized(_this), "handleInputChange", function (inputValue) {
        var actionMeta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EMPTY_OBJECT;
        var _this$props2 = _this.props,
          onInputChange = _this$props2.onInputChange,
          isAsyncInputClearable = _this$props2.isAsyncInputClearable;
        var currentInputValue = _this.state.inputValue;
        var isInputValuePresentOnMenuClose = actionMeta.action === 'menu-close' && currentInputValue !== inputValue;
        if (actionMeta.action === 'input-change' || isInputValuePresentOnMenuClose) {
          onInputChange(inputValue);
          return _this.setState({
            inputValue: inputValue,
            isLoading: true
          }, function () {
            var newInputValue = _this.state.inputValue;
            _this.handleInputLoadOptions(newInputValue, false, actionMeta);
          });
        }
        if (isAsyncInputClearable) {
          return _this.setState({
            inputValue: '',
            loadedInputValue: '',
            isLoading: false
          });
        }
        return null;
      });
      // currently this method is accessed and used via a ref.
      // if loadedOptions is empty, options are fetched again when menu is opened.
      _defineProperty(_assertThisInitialized(_this), "resetLoadedOptions", function () {
        _this.setState({
          loadedOptions: EMPTY_ARRAY
        });
      });
      _defineProperty(_assertThisInitialized(_this), "clearValue", function () {
        var onInputChange = _this.props.onInputChange;
        onInputChange(EMPTY_STRING);
        _this.setState({
          inputValue: EMPTY_STRING,
          isLoading: false
        });
      });
      var delaySearchBy = props.delaySearchBy,
        delayScrollBy = props.delayScrollBy;
      _this.handleOnScroll = _debounce(_this.handleOnScroll, delayScrollBy);
      _this.handleInputLoadOptions = _debounce(_this.loadOptions, delaySearchBy);
      _this.getSanitizedValue = getSanitizedValue();
      _this.state = {
        loadedOptions: props.defaultOptions || EMPTY_ARRAY,
        creatableOptions: EMPTY_ARRAY,
        isLoading: _isEmpty(props.defaultOptions),
        page: 0,
        inputValue: typeof props.inputValue !== 'undefined' ? props.inputValue : '' // react-select async
      };
      return _this;
    }
    _createClass(WithAsyncSelect, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var inputValue = this.props.inputValue;
        this.loadOptions(inputValue, false);
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps, prevState) {
        var _this$state3 = this.state,
          isMenuOpen = _this$state3.isMenuOpen,
          loadedOptions = _this$state3.loadedOptions,
          inputValue = _this$state3.inputValue,
          isLoading = _this$state3.isLoading;
        var _this$props3 = this.props,
          refreshOptions = _this$props3.refreshOptions,
          loadOptionsOnClear = _this$props3.loadOptionsOnClear,
          value = _this$props3.value;
        if (refreshOptions && prevProps.refreshOptions !== refreshOptions) {
          return this.loadOptions(inputValue, false);
        }
        if (loadOptionsOnClear && _isEmpty(value) && !_isEqual(prevProps.value, value)) {
          return this.loadOptions(inputValue, false);
        }
        if (prevState.isMenuOpen === isMenuOpen || !isMenuOpen || !_isEmpty(loadedOptions) || isLoading) return null;
        this.setState({
          isLoading: true
        });
        return this.loadOptions(inputValue, false);
      }
    }, {
      key: "render",
      value: function render() {
        var _this$state4 = this.state,
          inputValue = _this$state4.inputValue,
          isLoading = _this$state4.isLoading,
          loadedOptions = _this$state4.loadedOptions,
          creatableOptions = _this$state4.creatableOptions;
        var props = this.props;
        var isAsyncInputClearable = props.isAsyncInputClearable,
          searchCloseIconClass = props.searchCloseIconClass,
          restProps = _objectWithoutProperties(props, _excluded);
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SelectComponent, _extends({}, restProps, {
          styles: this.getSelectStyles(props.styles),
          value: this.getSanitizedValue(creatableOptions, props.value),
          inputValue: inputValue,
          onMenuScrollToBottom: this.handleOnScroll,
          onMenuScroll: this.handleOnScroll,
          onChange: this.handleChange,
          isLoading: isLoading,
          onInputChange: this.handleInputChange,
          options: loadedOptions,
          onMenuClose: this.onMenuClose,
          onMenuOpen: this.onMenuOpen,
          components: this.getSelectComponents(props.components, props.shouldIncludeDefaultComponents),
          ref: props.selectRef,
          hasError: !!props.error
        })), !isAsyncInputClearable && !_isEmpty(inputValue) && /*#__PURE__*/React.createElement(IconAsBtn, {
          size: SIZES.MD_S,
          onClick: this.clearValue,
          containerClassName: searchCloseIconClass
        }, "icon-close"));
      }
    }]);
    return WithAsyncSelect;
  }(PureComponent);
  WithAsyncSelect.propTypes = {
    defaultOptions: PropTypes.array,
    onChange: PropTypes.func,
    inputValue: PropTypes.string,
    loadOptions: PropTypes.func,
    value: PropTypes.any.isRequired,
    shouldFetchOnValueChange: PropTypes.bool,
    onInputChange: PropTypes.func,
    onMenuClose: PropTypes.func,
    delaySearchBy: PropTypes.number,
    delayScrollBy: PropTypes.number,
    refreshOptions: PropTypes.bool,
    isAsyncInputClearable: PropTypes.bool,
    shouldIncludeDefaultComponents: PropTypes.bool,
    searchCloseIconClass: PropTypes.string,
    loadOptionsOnClear: PropTypes.bool,
    onLoadOptionsSuccess: PropTypes.func
  };
  WithAsyncSelect.defaultProps = {
    defaultOptions: EMPTY_ARRAY,
    onChange: _noop,
    inputValue: '',
    loadOptions: function loadOptions() {
      return Promise.reject(new Error('Error'));
    },
    shouldFetchOnValueChange: false,
    onInputChange: _noop,
    onMenuClose: _noop,
    delaySearchBy: DELAY_SEARCH_BY,
    delayScrollBy: DELAY_SCROLL_BY,
    refreshOptions: false,
    isAsyncInputClearable: true,
    shouldIncludeDefaultComponents: true,
    searchCloseIconClass: EMPTY_STRING,
    loadOptionsOnClear: false,
    onLoadOptionsSuccess: _noop
  };
  return WithAsyncSelect;
}